import React from "react";
import { Alert } from '@deere/ux.uxframe-react';

const ErrorMsg = props => {
    return (
        <div>
            {props.message !== '' ?
                <Alert variant="danger" aria-atomic="true">
                    <h5 className="uxf-alert-title">{props.message}</h5>
                </Alert>
                : ""}
        </div>
    );
};
export default ErrorMsg;
